import { render, staticRenderFns } from "./restaurantCollections.vue?vue&type=template&id=d87a4b20&scoped=true&"
import script from "./restaurantCollections.vue?vue&type=script&lang=js&"
export * from "./restaurantCollections.vue?vue&type=script&lang=js&"
import style0 from "../../templateAssests/css/listing.css?vue&type=style&index=0&id=d87a4b20&scoped=true&lang=css&"
import style1 from "../../templateAssests/css/detail-page.css?vue&type=style&index=1&id=d87a4b20&scoped=true&lang=css&"
import style2 from "./restaurantCollections.vue?vue&type=style&index=2&id=d87a4b20&scoped=true&lang=css&"
import style3 from "./restaurantCollections.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87a4b20",
  null
  
)

export default component.exports